import { useEffect, useState } from "react";
import type { ExperienceSpec } from "@luxidar/experience-schema";
import type { BuilderAsset } from "./types";

export function usePreviewSpec(spec: ExperienceSpec | null, assets: readonly BuilderAsset[]): ExperienceSpec | null {
  const [previewSpec, setPreviewSpec] = useState<ExperienceSpec | null>(null);

  useEffect(() => {
    if (!spec) { setPreviewSpec(null); return; }
    const urls = new Map<string, string>();
    for (const asset of assets) urls.set(asset.id, URL.createObjectURL(asset.file));
    setPreviewSpec({
      ...spec,
      assets: spec.assets.map((asset) => ({ ...asset, src: urls.get(asset.id) ?? asset.src }))
    });
    return () => { for (const url of urls.values()) URL.revokeObjectURL(url); };
  }, [spec, assets]);

  return previewSpec;
}
